.card {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
    min-height: 7.5rem;
    padding: 0.75rem 0.85rem;
    cursor: pointer;
    text-align: left;
    font: inherit;
    border: 1px solid var(--mantine-color-gray-3);
    border-radius: var(--mantine-radius-md);
    background-color: var(--mantine-color-white);
    transition:
        border-color 100ms ease,
        box-shadow 100ms ease,
        transform 100ms ease;
}

.card:hover {
    border-color: var(--mantine-color-gray-5);
    box-shadow: 0 2px 6px rgba(16, 24, 40, 0.08);
}

.card:focus-visible {
    outline: 2px solid var(--mt-focus-ring);
    outline-offset: 1px;
}

/* Sticky-note variant: warmer paper, soft lift. */
.cardSticky {
    background-color: var(--mantine-color-gray-0);
    box-shadow: 0 1px 2px rgba(16, 24, 40, 0.1);
}

.cardSticky:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 10px rgba(16, 24, 40, 0.12);
}

.lane_needs_action.cardSticky {
    background-color: color-mix(in srgb, var(--mt-signal-attention-0) 55%, white);
}

.lane_notify_drivers.cardSticky {
    background-color: color-mix(in srgb, var(--mt-signal-pending-0) 55%, white);
}

.lane_dispatched.cardSticky {
    background-color: color-mix(in srgb, var(--mt-signal-positive-0) 45%, white);
}

.header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.65rem;
}

.title {
    font-size: var(--mantine-font-size-md);
    font-weight: 700;
    line-height: 1.35;
    line-clamp: 2;
    color: var(--mantine-color-dark-7);
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}

.spanHint {
    color: var(--mantine-color-gray-5);
    font-weight: 500;
}

.scheduleBlock {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 0.1rem;
    flex-shrink: 0;
}

.scheduleAnchorGroup {
    display: inline-flex;
    align-items: center;
    justify-content: flex-end;
    gap: 0.3rem;
    white-space: nowrap;
}

.schedule,
.scheduleTime,
.scheduleDuration {
    font-size: 0.75rem;
    line-height: 1.2;
    color: var(--mantine-color-gray-7);
    font-weight: 400;
    font-variant-numeric: tabular-nums;
    white-space: nowrap;
}

.scheduleStatus {
    display: inline-flex;
    align-items: center;
    padding: 0.08rem 0.3rem;
    border: 1px solid var(--mt-signal-attention-2);
    border-radius: var(--mantine-radius-sm);
    background-color: var(--mt-signal-attention-0);
    color: var(--mt-signal-attention-8);
    font-size: 0.6rem;
    line-height: 1.2;
    font-weight: 700;
    letter-spacing: 0.02em;
    text-transform: uppercase;
}

.scheduleTime {
    margin-top: 0.1rem;
}

.metaBlock {
    display: flex;
    flex-direction: column;
    gap: 0.05rem;
    font-size: var(--mantine-font-size-xs);
    line-height: 1.35;
    color: var(--mantine-color-gray-6);
}

.metaLine {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

/* Field-specific hooks for layout variants and future card styling. */
.jobCode,
.metaSeparator {
    display: inline;
}

.customer {
    display: inline;
    font-weight: 700;
    color: var(--mantine-color-gray-7);
}

.location,
.crew {
    display: block;
}

.progressRow {
    display: flex;
    flex-wrap: wrap;
    gap: 0.3rem;
    margin-top: 0.05rem;
}

.pill {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    padding: 0.08rem 0.4rem;
    border-radius: var(--mantine-radius-sm);
    font-size: 0.6875rem;
    line-height: 1.35;
    border: 1px solid transparent;
}

.pillCount {
    font-family: var(--mantine-font-family-monospace);
    font-weight: 700;
    font-variant-numeric: tabular-nums;
}

.pillLabel {
    color: inherit;
    opacity: 0.85;
}

.pillComplete {
    background-color: color-mix(in srgb, var(--mt-signal-positive-0) 70%, white);
    border-color: var(--mt-signal-positive-2);
    color: var(--mt-signal-positive-9);
}

.pillOpen {
    background-color: color-mix(in srgb, var(--mt-signal-attention-0) 70%, white);
    border-color: var(--mt-signal-attention-2);
    color: var(--mt-signal-attention-9);
}

.status {
    margin-top: auto;
    padding-top: 0.4rem;
    border-top: 1px solid var(--mantine-color-gray-1);
    font-size: var(--mantine-font-size-xs);
    line-height: 1.35;
    font-weight: 500;
}

.tone_critical {
    color: var(--mt-signal-attention-8);
    font-weight: 600;
}

.actionCta {
    border-top-color: color-mix(
        in srgb,
        var(--mt-signal-attention-2) 55%,
        var(--mantine-color-gray-1)
    );
}

.tone_attention {
    color: var(--mantine-color-gray-8);
}

.tone_calm {
    color: var(--mantine-color-gray-6);
    font-style: italic;
    font-weight: 400;
}

.highlighted {
    border-color: var(--mt-signal-pending-4);
    box-shadow: 0 0 0 2px var(--mt-signal-pending-2);
}

.partialPickup {
    font-size: var(--mantine-font-size-xs);
    font-weight: 600;
    line-height: 1.3;
    color: var(--mantine-color-orange-9);
    background-color: var(--mantine-color-orange-0);
    border-radius: var(--mantine-radius-xs);
    padding: 0.15rem 0.4rem;
}
